import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import UtilService from '../../../../../../../helper/service';
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const useStyles = makeStyles(() => ({
  verticalBar: {
    background: 'rgba(1, 122, 239, .3)',
    height: '100%',
    position: 'absolute',
    left: 20,
    zIndex: 1001,
    marginTop: -40,
    cursor: 'pointer'
  },
  barIcon: {
    marginLeft: -15,
    marginTop: 100
  },
  time: {
    color: '#017AEF',
    fontSize: 17,
    fontFamily: 'Spartan-extrabold',
    background: '#F0F0F0',
    width: 38,
    height: 18,
    paddingTop: 2,
    marginLeft: -18,
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
}));

const ScissorMarker = forwardRef((props: any, ref) => {

  ScissorMarker.displayName = 'ScissorMarker'

  const {
    position: { } = {},
    left,
    right,
    moving,
    onFirstPoint,
    finished,
    graphZoom,
    onSetVideoPlayed
  } = props;

  const classes = useStyles();
  const { analyseStart, cliped } = useSelector((state: any) => state.analysis);
  const start = cliped ? cliped.start_clip - analyseStart : 0;

  const [xPosition, setXPosition] = useState(0);
  const [xScrollPosition, setXScrollPosition] = useState(0);
  const sLeft = left ? left : finished ? right : (xPosition + xScrollPosition);
  const scissorLeft = moving ? sLeft : (left === 0 ? 0 : sLeft);

  useEffect(() => {
    onSetVideoPlayed && onSetVideoPlayed(UtilService.getTimeLabelClip((xPosition + xScrollPosition) / 15, graphZoom, start))
  }, [xPosition])

  useImperativeHandle(
    ref,
    () => ({
      containerScrolled(scrollAmount: any) {
        setXScrollPosition(Number(scrollAmount));
      },
      setMouseXPosition(xPos: any) {
        setXPosition(xPos);
      }
    }),
  )

  return (
    <div
      className={classes.verticalBar}
      style={{
        left: moving ? scissorLeft : (left === 0 ? 0 : scissorLeft),
        width: moving ? 0 : ((finished ? right : (xPosition + xScrollPosition)) - left),
        borderLeft: '2px solid #017AEF'
      }}
      onClick={() => {
        !finished && onFirstPoint(xPosition, xScrollPosition);
      }}
    >

      <div className={classes.time}>
        {UtilService.getTimeLabel(Math.ceil(scissorLeft) / 15, graphZoom, start)}
      </div>

      {!left && !finished && <img
        src={'/assets/icons/liveanalysis/blue-scissors.svg'}
        alt={'img'}
        className={classes.barIcon}
      />}
    </div>

  );
});

export default ScissorMarker;